import { EnvironmentProviders, ModuleWithProviders, NgModule, makeEnvironmentProviders } from '@angular/core';
import { sessionMonitoringConfig, SessionMonitoringConfig } from './session-monitoring.config';
import { SESSION_MONITORING_CONFIG } from './session-monitoring-config.token';

/**
 * @deprecated Use `provideSessionMonitoring` instead in the `providers` array.
 */
@NgModule()
export class SessionMonitoringModule {

  static withConfig(config: SessionMonitoringConfig): ModuleWithProviders<SessionMonitoringModule> {
    return {
      ngModule: SessionMonitoringModule,
      providers: [
        { provide: SESSION_MONITORING_CONFIG, useValue: config },
      ]
    }
  }
}

export const provideSessionMonitoring = (
  config: Partial<SessionMonitoringConfig> & Pick<SessionMonitoringConfig, 'refreshUrl'>
): EnvironmentProviders => makeEnvironmentProviders([
  { provide: SESSION_MONITORING_CONFIG, useValue: sessionMonitoringConfig(config) },
]);
